import {
  AxiosError,
  type AxiosInstance,
  type AxiosRequestHeaders,
} from 'axios';
import type { TAxiosResponseInterceptorError } from './types';
import { memoizedRefreshToken } from './refreshToken';
import { clearCookies } from '../cookies';
import { showNetworkErrorNotification } from '@shared/utils';

export const defaultHeaders: Partial<AxiosRequestHeaders> = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Accept-Language': 'ru',
};

export const getHandleAxiosError =
  (axiosInstance: AxiosInstance): TAxiosResponseInterceptorError =>
  async (error: AxiosError) => {
    const errorCode = error.code;
    const isNetworkError = errorCode === 'ERR_NETWORK';

    if (isNetworkError) {
      error.message = 'Ошибка соединения';
      showNetworkErrorNotification();

      return Promise.reject(error);
    }

    const config = error?.config as any;

    if (error?.response?.status === 401 && !config?.sent) {
      config.sent = true;

      await memoizedRefreshToken();

      return axiosInstance(config);
    }

    if (error?.response?.status === 401 && config?.sent) {
      clearCookies();

      window.location.href = '/auth';
    }

    return Promise.reject(error);
  };
